module.exports = __webpack_public_path__ + "30b27d2893b22998c3c8eb557d34f312.svg";